import { render } from "./DataDetails.vue?vue&type=template&id=28a09d2f"
import script from "./DataDetails.vue?vue&type=script&lang=js"
export * from "./DataDetails.vue?vue&type=script&lang=js"

import "./DataDetails.vue?vue&type=style&index=0&id=28a09d2f&lang=css"

import exportComponent from "/Users/aml/Projects/dashboardcopy2/fnbxv21-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__